import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store"; // Ou import store from './store/index.js'

import "./assets/css/global.scss"; // Importez vos styles globaux SCSS
import FeatherIcon from "vue-feather"; // Importez le composant FeatherIcon

const app = createApp(App);

app.use(store).use(router);

// Enregistrez le composant FeatherIcon globalement pour l'utiliser partout
app.component("FeatherIcon", FeatherIcon);

app.mount("#app");
